import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/portal.css';
import { App } from './App.js';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html has no #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
